import { TranslationModuleEnum } from "./translation-modules.enum";

export const sharedModules = [
  TranslationModuleEnum.shared,
  TranslationModuleEnum.designSystem,
  TranslationModuleEnum.manageWorkflow,
  TranslationModuleEnum.auth,
  TranslationModuleEnum.oops,
];
